import { Link } from "react-router-dom";
import { Gauge, Calendar } from "lucide-react";
import { euro, km } from "../lib/api";

export default function MotorcycleCard({ moto }) {
  const img = moto.images?.[0] || "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=800";
  const sold = moto.status === "verkocht";
  return (
    <Link
      to={`/motoren/${moto.id}`}
      data-testid={`moto-card-${moto.id}`}
      className="group block bg-[#141518] border border-[#2A2B31] hover:border-[#E10600]/60 transition-colors overflow-hidden"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#0A0A0B]">
        <img src={img} alt={`${moto.merk} ${moto.model}`} loading="lazy"
             className={`w-full h-full object-cover card-hover-img ${sold ? "opacity-50" : ""}`} />
        <div className="absolute top-0 left-0">
          <span className={`inline-block font-display uppercase text-xs font-700 tracking-wider px-3 py-1.5 ${
            sold ? "bg-[#2A2B31] text-[#9A9CA3]" : "bg-[#E10600] text-white"
          }`}>
            {sold ? "Verkocht" : "Beschikbaar"}
          </span>
        </div>
      </div>
      <div className="p-5">
        <p className="font-mono-tt text-xs text-[#E10600] uppercase tracking-widest mb-1">{moto.merk}</p>
        <h3 className="font-display uppercase font-700 text-xl text-white leading-none mb-3">{moto.model}</h3>
        <div className="flex items-center gap-4 text-xs text-[#9A9CA3] font-mono-tt mb-4">
          <span className="flex items-center gap-1.5"><Calendar size={13} /> {moto.bouwjaar || "—"}</span>
          <span className="flex items-center gap-1.5"><Gauge size={13} /> {km(moto.kilometerstand, moto.meeteenheid)}</span>
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-[#2A2B31]">
          <span className="font-display font-800 text-2xl text-white">{euro(moto.prijs)}</span>
          <span className="font-display uppercase text-xs font-600 text-[#9A9CA3] group-hover:text-[#E10600] transition-colors">Details →</span>
        </div>
      </div>
    </Link>
  );
}
